// data-testid registry for Trending Business Ideas app
export const APP = {
  // Landing
  landingHero: "landing-hero",
  landingCtaPrimary: "landing-cta-primary",
  landingCtaSecondary: "landing-cta-secondary",
  navLogo: "nav-logo",
  navLogin: "nav-login-btn",
  navSignup: "nav-signup-btn",
  navDashboard: "nav-dashboard-btn",
  navLogout: "nav-logout-btn",

  // Auth
  authForm: "auth-form",
  authEmailInput: "auth-email-input",
  authPasswordInput: "auth-password-input",
  authNameInput: "auth-name-input",
  authSubmitBtn: "auth-submit-btn",
  authToggleMode: "auth-toggle-mode",
  authError: "auth-error",

  // Dashboard - generator
  filterCategory: "filter-category",
  filterBudget: "filter-budget",
  filterSkill: "filter-skill",
  filterMarket: "filter-market",
  filterCountry: "filter-country",
  filterCurrency: "filter-currency",
  filterCount: "filter-count",
  generateBtn: "generate-btn",
  generateLoading: "generate-loading",
  generateError: "generate-error",

  // Billing
  usageBadge: "usage-badge",
  planBadgePro: "plan-badge-pro",
  paywallDialog: "paywall-dialog",
  paywallUpgradeBtn: "paywall-upgrade-btn",
  paywallCloseBtn: "paywall-close-btn",
  upgradeCtaBtn: "upgrade-cta-btn",

  // Referral
  referralBanner: "referral-banner",
  referralCodeBox: "referral-code-box",
  referralCopyBtn: "referral-copy-btn",
  referralShareBtn: "referral-share-btn",
  authReferralInput: "auth-referral-input",

  // Feedback
  feedbackNavBtn: "feedback-nav-btn",
  feedbackDialog: "feedback-dialog",
  feedbackComment: "feedback-comment",
  feedbackEmail: "feedback-email",
  feedbackStar: "feedback-star",
  feedbackSubmit: "feedback-submit",

  // Idea card
  ideaCard: "idea-card",
  ideaTitle: "idea-title",
  ideaSaveBtn: "idea-save-btn",
  ideaExpandBtn: "idea-expand-btn",
  ideaDeepDiveBtn: "idea-deep-dive-btn",

  // Deep Dive
  deepDiveDrawer: "deep-dive-drawer",
  deepDiveLoading: "deep-dive-loading",

  // Saved
  tabGenerator: "tab-generator",
  tabSaved: "tab-saved",
  savedList: "saved-list",
  savedItem: "saved-item",
  savedDeleteBtn: "saved-delete-btn",
  savedEmpty: "saved-empty",

  // Share
  shareBtn: "share-btn",
  sharedPage: "shared-page",
  sharedPageCta: "shared-page-cta",

  // Reality Check regenerate
  realityCheckRegenBtn: "reality-check-regen-btn",
};
